// @ts-nocheck
import React from 'react';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';
import KwPanel from '../../../common/KwPanel';
import { toast } from 'react-toastify';
import Button from '../../../common/Button';
import ConfirmationHeader from '../../../common/ConfirmationHeader';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../hooks';
import { deleteDisableReason } from '../../../../reducers/disableReasonReducer';

function DeleteDisabledReason({ done, id, cancel }) {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const handleDelete = () => {
    dispatch(deleteDisableReason(id))
      .unwrap()
      .then(() => {
        toast.success(t('Disable reason successfully deleted'));
        done();
      })
      .catch(() => {
        toast.error(t('Failed to disable reason template'));
      });
  };

  return (
    <SlideoutLayout
      title={t('Delete confirmation')}
      cancel={cancel}
      done={done}
    >
      <KwPanel>
        <ConfirmationHeader text={t('Are you sure?')} />
        <Button
          className="btn btn-danger me-2"
          onClick={handleDelete}
          text={t('Yes, delete the disabled reason')}
        />
        <Button
          className="btn btn-default"
          onClick={cancel}
          autoFocus={true}
          text={t('No, cancel')}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}


export default DeleteDisabledReason;
